export const environment = {
  production: false,
  pr1ApiUrl: '/Private',
  appKey: 'core',
  environment:"dev2",
  appMode: "shopify",
  shopifyAuth:{
    apiKey: '437d3eb5c5cfdc0d1fb4369c2e49240b',
    host: 'YWRtaW4uc2hvcGlmeS5jb20vc3RvcmUvcXVpY2tzdGFydC0xMWI3YzdmNA'
  },
  applicationInsights: {
    instrumentationKey: '89111394-0f35-45c3-85ef-3b717c84c902', // development environment
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
  },
  auth: {
    domain: 'dev-hn16g194.us.auth0.com',
    clientId: '2BuxUAB3s2SMOzQBOIwG04EZlxDV5cLC',
    audience: 'https://pr1-std-private-api.przone.net',
    organization: 'org_HjNjnLSP4hS3rpdV',
    redirectUri: window.location.origin + "/pr1core/",
  },
  httpInterceptor: {
    allowedList: [`/*`],
  },
  blobStorage: {
    kroger: {
      assetsUrl: "https://pr1stddevstandardblob.blob.core.windows.net/public/assets",
      digitaladportalUrl: "http://127.0.0.1:5173"
    },
    riteaid: {
      assetsUrl: "https://pr1stddevstandardblob.blob.core.windows.net/public/assets",
      digitaladportalUrl: "http://127.0.0.1:5173"
    },
    standard: {
      assetsUrl: "https://pr1stddevstandardblob.blob.core.windows.net/public/assets",
      digitaladportalUrl: "http://127.0.0.1:5173"
    },
    walgreens: {
      assetsUrl: "https://pr1stddevstandardblob.blob.core.windows.net/public/assets",
      digitaladportalUrl: "http://127.0.0.1:5173"
    },
    demo: {
      assetsUrl: "https://pr1stddevstandardblob.blob.core.windows.net/public/assets",
      digitaladportalUrl: "http://127.0.0.1:5173"
    },
    qaautomation: {
      assetsUrl: "https://pr1stddevstandardblob.blob.core.windows.net/public/assets",
      digitaladportalUrl: "http://127.0.0.1:5173"
    },
    unfi: {
      assetsUrl: "https://pr1stddevstandardblob.blob.core.windows.net/public/assets",
      digitaladportalUrl: "https://pr1stddevstandardblob.blob.core.windows.net/public/digitaladportal"
    },
    shopify: {
      assetsUrl: "https://pr1stddevstandardblob.blob.core.windows.net/public/assets",
      digitaladportalUrl: "https://pr1stddevstandardblob.blob.core.windows.net/public/digitaladportal"
    },
  }
};
